import * as _ from "lodash";
import request from "@/utils/request";
import base_ds from "@/services/base_datasource_service";
import { AxiosResponse } from "axios";
import { IResponseResult } from "@/services/data/base_types";
import {
  AcceptChangeSchema,
  AcceptData,
  AcceptDataBackend,
  EcoVersionType,
  PtnBuisnessPeriondType
} from "./models-service";

const route_ns = `dicts/ptn_business_period`;

class PtnBuisnessPeriodService {

    data_source = base_ds.getBaseDataSource(route_ns);
    public crud = base_ds.getBaseCrud(route_ns);


  constructor() {
    //
  }

  public async get(): Promise<IResponseResult<PtnBuisnessPeriondType[]>> {
    const response: AxiosResponse["data"] = await this.crud.get();

    if (response?.data) {
      return {data: response.data as PtnBuisnessPeriondType[] };
    } else {
      return { data: null, message: "" };
    }
  }

  empty() {

  }

}

export default new PtnBuisnessPeriodService();
